export default __webpack_public_path__ + "static/media/100_45657.db1b0406.jpg";